export default (
    Object.freeze({
        planType: {
            GIA: 'gia',
            InvestmentISA: 'isa',
            JISA: 'jisa',
            SIPP: 'sipp',
            InstantAccessCash: 'iasa',
            CashISA: 'cash-isa',
            Contributor: 'contributor'
        },
        variants: {
            Primary: 'primary',
            PrimaryEmphasis: 'primary-emphasis',
            Secondary: 'secondary',
            Tertiary: 'tertiary',
        },
        states: {
            Info: 'info',
            Success: 'success',
            Warning: 'warning',
            Danger: 'danger',
        },
        sizes: {
            Micro: 'micro',
            Small: 'small',
            Medium: 'medium',
        }
    })
);